import styled from 'styled-components';

export const ContainerDrop = styled.div`
  height: 300px;
  margin: 40px 0px 0px;
  outline: 0;
  background: #f0f0f5;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  

  &:hover{
    cursor: pointer;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  p {
    width: calc(100% - 60px);
    height: calc(100% - 60px);
    color: #333;
    border: 1px dashed #999;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  svg {
    width: 24px;
    height: 24px;
    margin-bottom: 8px;
  }
`;
